import React from 'react'
import PropTypes from 'prop-types'

const WRAPPER_CLASS = 'tw:flex tw:min-h-[60vh] tw:items-center tw:justify-center'

const CenteredState = ({ children }) => <div className={WRAPPER_CLASS}>{children}</div>

CenteredState.propTypes = {
  children: PropTypes.node.isRequired
}

export default CenteredState
